import BackboneMeetingsContainer from './backbone_meetings_container';

export default BackboneMeetingsContainer;
